/***
 * 创建人：李珊
 * 时间：2022-12-29
 * 描述:图像标记详情页面
 * 更新说明:
 */
import { Component, OnInit, AfterViewInit, ViewChild, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { KmsService } from '../../../kms.service';
import { environment } from 'src/environments/environment';
import { SwMassageBoxService } from '../../../../../librarys/serves/sw-massage-box.service';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { SwTabService } from 'src/app/librarys/serves/public/sw-tab.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { InstanceInfoViewComponent } from '../../../components/instance-info-view/instance-info-view.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
declare var $: any, OpenSeadragon: any;

@Component({
  selector: 'app-resource-mark',
  templateUrl: './resource-mark.component.html',
  styleUrls: ['./resource-mark.component.css']
})
export class ResourceMarkComponent implements OnInit {
  // 重命名弹框
  @ViewChild('addMarkModal') addMarkModal: SwModalframeComponent;
  //筛选标记弹框
  @ViewChild('modal') modal: SwModalframeComponent;  
  //确认删除弹框
  @ViewChild("trim") trim: SwMassageConfirmComponent; 
  // 接收父组件的数据：图像标记入口
  @Input() addPath:any;
  // 接收父组件的数据：素材内容
  @Input() materialContent: any;
  // 向父组件传值
  @Output() componentState = new EventEmitter();
  //OpenSeadragon对象
  viewer: any;       
  //OpenSeadragonHTMLelements            
  hEl: any;           
  //OpenSeadragonSelection
  selection:any;
  //默认缩放比例
  zoom:number;
  params: any = {   
    bigImgUrl: '',            // 图片路径
    fileInfoId: '',           // 图片文件主键id
    imgCreator:'' ,           // 上传图片的用户id
    createUsers: [],          // 当前选中的创建人id集合，用于标注列表查询
    showMarkList: false,      // 标注列表组件是否显示
    showMarkEdit: false,      // 标记编辑组件是否显示
    showMarkDetail: false,    // 标记详情组件是否显示
    mode: '',                 // 状态：查看/编辑/质检
    currentMarkId: '',        // 当前正在操作的标记id,新增时默认为空
    markName: '',             // 当前标记的标记名称（默认为空，新增标记保存成功后，由子组件传回父组件）
    region:[],                // 小图的x,y,width,height   
    operateState: '',         // 1: 编辑标记信息；2：修改区域图；3：描边；4：修改定位坐标 
    point: {},                // 定位坐标 
    points: [],               // 描边点集合
    currentMarkName: ''     
  };  
  //从后台读取的标注信息
  annotationList = [];  
  //是否全屏 
  isFullScreen = false; 
	// OpenSeadragonCanvasOverlay对象
	overlay;
  // 是否正在进行图层叠加操作
  isLayerOverlay = false;
  overlayArr:any = [];
  addMarkName:string = '';
  // 是否已有绘制完成的面
	hasDrawed = false;
	// 绘制类型 line:线；surface:面
	drawType = 'line';
	// 当前取到的点的集合
  clickPointArr = [];
  // 鼠标点击取点时是进行什么操作：0:不进行任何操作；1：取点描边；2：取点，定位坐标
  drawClassify = 0;
  // 定位坐标
  point:any = {};
  // 标注创建人集合
  createUserArr = [];
  // 标注创建人集合
  copyCreateUserArr = [];
  // 描边宽度标准值
  standardValue = 0.003;
  // 描边配置
  strokeConfig:any = {
    'inCircleColor': '#FFFFFF',      // 描边-点的内层圆颜色
    'outCircleColor': '#FB9E25',     // 描边-点的外层圆颜色
    'strokeColor':'#FB9E25',         // 描边-连线颜色
    'areaColor': 'rgba(251,158,37,0.3)',  // 描边-面的背景颜色
    'pointColor': '#e9901c',              // 定位点的外层圆颜色
    'lineDash': [2,2],                     // 描边-连线的间隔区间
    'inRadius': null,                     // 描边-点的内层圆半径
    'outRadius': null,                    // 描边-点的外层圆半径
    'strokeWidth': null                   // 描边-连线宽度
  }; 
  //用户信息
  UserModel: any = {};
  // 图片关联实体信息
  instanceArr:any = [];
  instanceIndex = -1;
  // 默认是否展开关联实体信息
  showInstance = false;
  // 是否展示实体列表下拉框
  showInstanceList = false;
  // 监听新增/编辑标记信息时标记信息是否发生变化
  markValueChange = false;
  // 图像标记管理：编辑/查看标记-传入的标记id
  initMarkId:string = ''; 
  constructor(
    private router: Router,
    private tabServe: SwTabService,
    private routeInfo: ActivatedRoute,
    private kmsService: KmsService,
    private box: SwMassageBoxService,
    public  instanceModuleService:InstanceModuleService,
    private jwt: SwJwtService,
    private create:SwCreateModalComponentService,
    private User: GetUserModelService
  ) { 
    // 获取用户信息
    this.UserModel = this.User.getUser();
  }

  ngOnInit() {
    this.routeInfo.queryParams.subscribe((data: Params) => {
      if(this.addPath != 'quickMenu'){
        // 获取路由参数 
        const params = JSON.parse(data["selectedData"]);
        this.init(params);
        console.log(this.addPath);
      }
    });
  }

  ngOnChanges(){
    // 快捷菜单
    if(this.materialContent.upOrAdd == 'markImg'){
      const params = this.materialContent.imgData;
      this.init(params);
      console.log(this.addPath);
    }
  }
  
  init(params){
    // 清除上一次质检选择的标记信息
    this.jwt.setToKen('markVerifyConfig','');
    // this.params.bigImgUrl = "http://122.112.235.243:8282/iiif/2/aa3664193b7511eb9cf8000c292fb426kgs%2FKMS%2FKMS_INSTANCE_RESOURCE_TESTZSK%2F%2F20230530%2F637e3d4f0c204a8c84d03dcad13bc4bb.jpg/"
    // this.params.bigImgUrl = "http://122.112.235.243:8282/iiif/2/aa3664193b7511eb9cf8000c292fb426kgs%2FKMS%2FKMS_INSTANCE_RESOURCE_TESTZSK%2F%2F20230619%2F7278dc078a1543dd86b391132efd7600.jpg/";
    this.params.bigImgUrl = this.getIiifImgUrl(params['filePath']);
    this.params.fileInfoId = params['materialId'];
    this.params.imgCreator = params['createUserId'];
    this.params.mode = params['mode'];
    if(params['imageMarkId']){
      this.initMarkId = params['imageMarkId'];
    }
    // 查询图片资源关联实体信息
    this.queryRelatedInstance()
    // 查询所有的标记创建人信息
    this.queryMarkCreater();
    // 展示大图
    this.viewer = OpenSeadragon({
      //装载到的容器id
      id: "pic",
      //指定库中按钮等图片所在文件夹
      prefixUrl: "./assets/Scripts/openseadragon/img/openseadragon-imgs/",
      visibilityRatio: 0,                    // 规定了图像在显示框中最少要保留的比例，默认值0.5,范围0-1,0表示图像可以完全被移动到显示框之外，1表示，图像一点也不能被移动到显示框之外.
			constrainDuringPan: false,                // 规定了图像是否能被拖拽出允许最小范围，true为不允许，false为允许
      //最小放大倍数
      minZoomLevel: 0.01,          
      //最大放大倍数
      maxZoomLevel: 16,   
      //sequenceMode设置为true,代表加载的是一张图片而非一个图片合集        
      sequenceMode: true,
      //是否显示全屏按钮
      showFullPageControl: false,
      //是否显示前进后退按钮
      showSequenceControl: false,
      //是否显示导航缩略图
      showNavigator: false,   
      //当鼠标移出图片区域时，是否自动隐藏导航视图和缩略图
      autoHideControls: false,
      // panHorizontal: false,   // 禁用横向拖动
      // panVertical: false,     // 禁用竖向拖动
      //鼠标事件设置
      gestureSettingsMouse: {            
        // dragToPan: false,     // 禁用拖拽移动
        // scrollToZoom: false,  // 禁用鼠标滚轮缩放
        clickToZoom: 0,          // 禁用单击放大功能
      },
      //所要显示的源图片信息
      tileSources: [this.params.bigImgUrl + "info.json"],
      // tileSources: {
			// 	Image : {
			// 		Format: "png",
			// 		xmlns: "http://schemas.microsoft.com/deepzoom/2009",
			// 		Url : "https://shuziwenwu-1259446244.cos.ap-beijing.myqcloud.com/relic/1714914937058824192/image-bundle/",
			// 		TileSize : "510",
			// 		Overlap : "2",
			// 		Size : {
			// 			"Height": "3598",
			// 			"Width": "4798"
			// 		}
			// 	}
			// },
      timeout: 60000
    });
  
    let that = this;
    if(that.params.mode == 'edit' || that.params.mode == 'verify'){
      //配置框选参数，定义添加标注功能
      const odOption = {
        allowRotation: false,         
        //定义确认当前选区后执行的方法
        onSelection: function (rect) { 
          if(that.isLayerOverlay){
            that.box.danger('请先退出标记图层叠加状态！');
            return;
          }
          // 标记编辑组件处于显示状态，说明当前是进行修改区域图操作
          if(that.params.showMarkEdit){
            rect['id'] = that.params.currentMarkId;
            that.markValueChange = true;
            // 先清除之前的区域图
            // 判断当前是编辑标注还是新增标注操作
            if (rect['id']) {
              // 编辑标注时需获取当前标注名称
              let divEle = that.hEl.getElementById('mark_'+rect['id']).element.getElementsByClassName('markOverlay');
              if(divEle && divEle.length>0){
                rect['text'] =divEle[0].getElementsByClassName('markName')[0].innerText;
                that.hEl.removeElementById('mark_'+rect['id']);
              }else{
                rect['text'] = that.params.markName;
                that.hEl.removeElementById('mark_current');
              }
            }else{
              that.hEl.removeElementById('mark_current');
            }
            // 修改组件状态
            that.params.operateState = '2';
            // 修改选区图片路径参数
            that.params.region = [rect.x, rect.y, rect.width, rect.height]; 
            let x = that.params.region[0] + that.params.region[2] / 2;
            let y = that.params.region[1] + that.params.region[3] / 2;
            that.point = {
              x: x,
              y: y
            }
            rect['cx'] = null;
            rect['cy'] = null;
            that.addLayer(rect,true);
            // 框选之后默认将缩放比例添加0.0001，使标注显示
            const zoom = that.viewer.viewport.getZoom();
            that.viewer.viewport.zoomTo(zoom + 0.0001);
            // 关闭框选功能
            that.selection.disable();
            return true;
          }
          // 当前是新增标注操作
          else{
            // 显示标记编辑组件(如果当前展示了标注列表组件，需先关闭标注列表再打开标记编辑)
            if(that.params.showMarkList){
              that.toggleMarkList(false);
              setTimeout(()=>{
                that.toggleMarkEdit(true);
              },700);
            }
            // 显示标记编辑组件(如果当前展示了标注详情组件，需先关闭标注详情再打开标记编辑)
            else if(that.params.showMarkDetail){
              that.toggleMarkDetail(false);
              setTimeout(()=>{
                that.toggleMarkEdit(true);
              },700);
            }else{
              that.toggleMarkEdit(true);
            }
            // 修改当前标注id
            that.params.currentMarkId = '';
            // 修改组件状态
            that.params.operateState = '1';
            that.params.points = [];
            that.clickPointArr = [];
            // 修改选区图片路径参数
            that.params.region = [rect.x, rect.y, rect.width, rect.height];
            let x = that.params.region[0] + that.params.region[2] / 2;
            let y = that.params.region[1] + that.params.region[3] / 2;
            that.point = {
              x: x,
              y: y
            }
            // 绘制选区图片所在的矩形
            rect.id = '';
            rect['cx'] = null;
            rect['cy'] = null;
            that.addLayer(rect);
            // 框选之后默认将缩放比例添加0.0001，使标注显示
            const zoom = that.viewer.viewport.getZoom();
            that.viewer.viewport.zoomTo(zoom + 0.0001);
            // 关闭框选功能
            that.selection.disable();
            that.hasDrawed = false;
            return true;
          }
        },
        prefixUrl: null,    
        // 重写导航按钮图标文件
        navImages: {        
          selection: {
            REST: 'selection_rest.png',
            GROUP: 'selection_grouphover.png',
            HOVER: 'selection_hover.png',
            DOWN: 'selection_pressed.png'
          },
          selectionConfirm: {
            REST: 'selection_confirm_rest.png',
            GROUP: 'selection_confirm_grouphover.png',
            HOVER: 'selection_confirm_hover.png',
            DOWN: 'selection_confirm_pressed.png'
          },
          selectionCancel: {
            REST: 'selection_cancel_rest.png',
            GROUP: 'selection_cancel_grouphover.png',
            HOVER: 'selection_cancel_hover.png',
            DOWN: 'selection_cancel_pressed.png'
          }
        }
      };
      this.selection = this.viewer.selection(odOption);
    }

    //获取OpenSeadragonHTMLelements对象
    this.hEl = this.viewer.HTMLelements();
  
    // 监听打开图片操作
    this.viewer.addHandler("open", () => {
      // 设置图片默认宽度或高度占满展示
      // this.viewer.viewport.fitHorizontally();
      this.viewer.viewport.fitVertically();
      that.setStrokeConfig(that.viewer.source.width,that.viewer.source.height);
      // 按钮提示信息汉化
      $('div[title="Zoom in"]').attr('title', '放大');
      $('div[title="Zoom out"]').attr('title', '缩小');
      $('div[title="Go home"]').attr('title', '返回主位置');
      $('div[title="Toggle selection"]').attr('title', '切换框选功能');
      // 获取标注信息并绘制标注
      this.drawAllMarks(true);
      // 绑定按钮组点击事件
      this.onPicButtonsClick();
    });

    // 对OpenSeadragon.Viewer#canvas element添加按下键盘事件
    this.viewer.addHandler('canvas-key', function(event) {
      // 当前按键为'backspace'时
      if(event.originalEvent.keyCode == '8'){
        // 当前为描边操作，且描边未绘制完成，存在点集合时，可返回上一次取点状态
        if(that.drawClassify == 1 && !that.hasDrawed && that.clickPointArr.length>0){
          let newPoints = that.clickPointArr.slice(0,that.clickPointArr.length-1);
          that.clickPointArr = JSON.parse(JSON.stringify(newPoints));
          that.drawSurface('line');
        }
      }
    });

    // 对OpenSeadragon.Viewer#canvas element添加单击事件
    this.viewer.addHandler('canvas-click', function(event) {
      let webPoint = event.position;
      let viewportPoint = that.viewer.viewport.pointFromPixel(webPoint);
      let imagePoint = that.viewer.viewport.viewportToImageCoordinates(viewportPoint);

      // 判断是否开启画笔工具且当前操作是否为描边
      if(that.drawClassify == 1){
        if(!that.hasDrawed && that.params.points.length == 0){
          // 判断当前是否重复取点
          const len = that.clickPointArr.filter(item => item.x == imagePoint.x).length;
          if(len == 0){
            that.clickPointArr.push(imagePoint);
          }
          that.drawSurface('line');
        }else{
          that.box.danger('请先清除之前绘制的描边!');
        }
      }
      // 判断是否开启画笔工具且当前操作是否为取点
      else if(that.drawClassify == 2){
        that.point = imagePoint;
        that.params.operateState = '4';
        that.params.point = that.point;
        that.drawSurface('point');
        $('.togglePointBtn').trigger('click');
      }
      else{
        // 是否正在进行标记图层叠加功能
        if(that.isLayerOverlay){
          that.overlayArr.push(imagePoint);
          that.drawSurface('layerOverlay');
        }
      }
    });
    
    // 对OpenSeadragon.Viewer#canvas element添加双击事件
    this.viewer.addHandler('canvas-double-click', function(event) {
      // 判断是否开启画笔工具
      if(that.drawClassify == 1 && !that.hasDrawed){
        that.drawSurface('surface');
        that.hasDrawed = true;
        that.params.operateState = '3';
        that.params.points = that.clickPointArr;
        $('.toggleStrokeBtn').trigger('click');
      }
    });
  }

  // 绑定按钮组点击事件
  onPicButtonsClick(){
    const that = this;
    //自定义切换描边功能
    $('.toggleStrokeBtn').click(function () {
      //判断当前是否处于开启描边状态
      if (that.drawClassify == 1) {
        $(this).find('img.notSelected').show();
        $(this).find('img.selected').hide();
        $('.openseadragon-canvas').css('cursor','default');
        that.drawClassify = 0;
      } else {
        $(this).find('img.notSelected').hide();
        $(this).find('img.selected').show();
        $('.togglePointBtn').find('img.notSelected').show();
        $('.togglePointBtn').find('img.selected').hide();
        $('.openseadragon-canvas').css('cursor','crosshair');
        that.drawClassify = 1;
      }
    });

    //自定义取点功能
    $('.togglePointBtn').click(function () {
      //判断当前是否处于开启取点状态
      if (that.drawClassify == 2) {
        $(this).find('img.notSelected').show();
        $(this).find('img.selected').hide();
        $('.openseadragon-canvas').css('cursor','default');
        that.drawClassify = 0;
      } else {
        $(this).find('img.notSelected').hide();
        $(this).find('img.selected').show();
        $('.toggleStrokeBtn').find('img.notSelected').show();
        $('.toggleStrokeBtn').find('img.selected').hide();
        $('.openseadragon-canvas').css('cursor','crosshair');
        that.drawClassify = 2;
      }
    });

    //自定义全屏事件
    $('.fullPageBtn').click(function () {
      that.isFullScreen = !that.isFullScreen;
      //判断当前是否处于全屏状态
      if (that.isFullScreen) {
        $(this).find('img.notSelected').hide();
        $(this).find('img.selected').show();
      } else {
        $(this).find('img.notSelected').show();
        $(this).find('img.selected').hide();
      }
    });

    //自定义查看标注列表事件
    $('.toggleListBtn').click(function () {
      if(that.isLayerOverlay){
        that.box.danger('请先退出标记图层叠加状态！');
        return;
      }
      if(!that.params.showMarkList && that.params.showMarkEdit){
        // 判断表单内容是否发生变化
        if(that.markValueChange){
          that.trim.openCLick('当前标注信息未保存，是否确定离开？', (data) => {
            if (data) {
              that.toggleMarkEdit(false);
              setTimeout(()=>{
                that.toggleMarkList(true);
              },700);
            }
          });
        }else{
          that.toggleMarkEdit(false);
          setTimeout(()=>{
            that.toggleMarkList(true);
          },700);
        }
      }else if(!that.params.showMarkList && that.params.showMarkDetail){
        that.toggleMarkDetail(false);
        setTimeout(()=>{
          that.toggleMarkList(true);
        },700);
      }else{
        that.toggleMarkList(!that.params.showMarkList);
      }
    });

    //自定义标记筛选功能
    $('.markFilterBtn').click(function () {
      if(that.params.showMarkEdit){
        that.box.danger('请先退出标记编辑状态！');
        return;
      }
      if(that.params.showMarkDetail){
        that.box.danger('请先退出标记查看状态！');
        return;
      }
      if(that.isLayerOverlay){
        that.box.danger('请先退出标记图层叠加状态！');
        return;
      }
      that.modal.toggle();
      $('.markFilterBtn').find('img.selected').show();
      $('.markFilterBtn').find('img.notSelected').hide();
      let str = JSON.stringify(that.createUserArr);
      that.copyCreateUserArr = JSON.parse(str);
    });

    //自定义查看关联实体功能
    $('.toggleLeftBoxBtn').click(function () {
      that.toggleQueryInstance(!that.showInstance)
    });

    //自定义标记图层叠加功能 
    $('.layerOverlayBtn').click(function () {
      if(that.params.showMarkEdit){
        that.box.danger('请先退出标记编辑状态！');
        return;
      }
      if(that.params.showMarkDetail){
        that.box.danger('请先退出标记查看状态！');
        return;
      }
      if(that.isLayerOverlay){
        return;
      }
      $('.layerOverlayBtn').find('img.selected').show();
      $('.layerOverlayBtn').find('img.notSelected').hide();
      that.isLayerOverlay = true;
      that.overlayArr = [];
    });
  }

  // 确定进行标记图层叠加
  overlaySureClick(){
    if(this.overlayArr.length<2){
      this.box.info('请至少选择两个点');
      return;
    }
    this.addMarkModal.toggle();
  }

  saveAddMark(){ 
    let pointStr = '';
    this.overlayArr.forEach((el,index) => {
      if(index == 0){
        pointStr += (el.x+','+el.y);
      }else{
        pointStr += (','+el.x+','+el.y);
      }
    })
    let params = {
      "X": pointStr,
      "material_id": this.params.fileInfoId,
      "save_name": this.addMarkName
    };
    this.kmsService.autoGetImgMarkByPoint(params).subscribe(
      res => {
        this.box.info('添加成功！');
        this.addMarkModal.toggle();
        this.addMarkName = '';
        this.overlayCancelClick();
        // 查询对当前图片标注过的所有用户
        this.queryMarkCreater(true);
      }
    )
  }

  cancelAddMark(){
    this.addMarkModal.toggle();
  }

  // 取消标记图层叠加
  overlayCancelClick(){
    $('.layerOverlayBtn').find('img.notSelected').show();
    $('.layerOverlayBtn').find('img.selected').hide();
    this.isLayerOverlay = false;
    this.overlayArr = [];
    this.drawSurface('empty');
    this.addMarkName = '';
  }

  // 显示/隐藏关联实体弹框
  toggleQueryInstance(state){
    this.showInstance = state;
    if(state){
      this.instanceIndex = this.instanceIndex == -1 ? 0 : this.instanceIndex;
      $('#queryInstances').animate({
        'left': '15'
      }, 600);
      $('.toggleLeftBoxBtn').find('img.notSelected').hide();
      $('.toggleLeftBoxBtn').find('img.selected').show();
    }else{
      $('#queryInstances').animate({
        'left': '-365'
      }, 600);
      $('.toggleLeftBoxBtn').find('img.notSelected').show();
      $('.toggleLeftBoxBtn').find('img.selected').hide();
    }
  }

  // 显示/隐藏标注列表弹框
  toggleMarkList(state){
    this.params.showMarkList = state;
    if(state){
      $('#queryMarks').animate({
        'right': '20'
      }, 600);
      $('.toggleListBtn').find('img.notSelected').hide();
      $('.toggleListBtn').find('img.selected').show();
    }else{
      $('#queryMarks').animate({
        'right': '-560'
      }, 600);
      $('.toggleListBtn').find('img.notSelected').show();
      $('.toggleListBtn').find('img.selected').hide();
    }
  }

  // 获取标注信息并绘制标注
  drawAllMarks(isInitLoad?){
    // 移除之前绘制的标注
    for (let i = 0; i < this.annotationList.length; i++) {
      const item = this.annotationList[i];
      this.hEl.removeElementById('mark_'+item.imageMarkId);
    }
    // 根据图片资源主键id和创建人查询全部标记信息
    let params = {
      fileInfoId: this.params.fileInfoId,
      createUserList: this.params.createUsers
    }
    this.kmsService.queryMarkByParam(params).subscribe(
      data => {
        if(data.code == '200'){
          if (data.data && data.data.length>0) {
            this.annotationList = data.data;
            // 绘制标记
            this.annotationList.forEach(item => {
              const rect = {
                x: parseFloat(item.position.split(',')[0]),
                y: parseFloat(item.position.split(',')[1]),
                width: parseFloat(item.width),
                height: parseFloat(item.height),
                text: item.markName,
                id: item.imageMarkId,
                cx: item.point ? parseFloat(item.point.split(',')[0]) : null,
                cy: item.point ? parseFloat(item.point.split(',')[1]) : null,
              };
              let state = (item.imageMarkId == this.params.currentMarkId);
              this.addLayer(rect,state);
            })
            //保存之后默认将缩放比例添加0.0001，使标注显示
            const zoom = this.viewer.viewport.getZoom();
            this.viewer.viewport.zoomTo(zoom + 0.0001);
            if(isInitLoad && this.initMarkId){
              let markParams = {
                imageMarkId: this.initMarkId
              }
              if(this.params.mode == 'edit' || this.params.mode == 'verify'){
                this.clickEdit(markParams);
              }else{
                this.clickView(markParams);
              }
            }
          }else{
            this.annotationList = [];
            return;
          }
        }else{
          this.box.waring(data.msg);
        }
      }
    )
  }

  //添加矩形标注及标注文字,返回值为添加的标注的id属性
  addLayer(rect: any,isEditImg?) {
    const markElement = document.createElement("div");
    const id = rect.id ? 'mark_' + rect.id : 'mark_current';
    // 当前为新增标注或修改标注区域图操作时需添加编辑中样式
    markElement.className = (!rect.id || isEditImg) ? 'markOverlay markEditing' : 'markOverlay';
    markElement.id = id;
    const ele = {
      id: id,
      element: markElement,
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    };
    this.hEl.addElement(ele);
    let divEle = this.hEl.getElementById(id).element.getElementsByClassName('markOverlay')[0];
    if (rect.id) {
      let circlePx = 50;
      let circlePy = 50;
      if(rect.cx){
        circlePx = (rect.cx-rect.x)/rect.width*100;
        circlePy = (rect.cy-rect.y)/rect.height*100;
      }
      
      // 插入标注元素节点
      divEle.innerHTML = '<div class="box"></div>'+
                        '<span class="markName">' + rect.text + '</span>' +
                        '<div class="circle"></div>';
      divEle.getElementsByClassName('circle')[0].title = rect.text;
      // 设置标记定位坐标
      divEle.getElementsByClassName('circle')[0].style.left = circlePx+'%';
      divEle.getElementsByClassName('circle')[0].style.top = circlePy+'%';
      divEle.getElementsByClassName('markName')[0].style.left = circlePx+'%';
      divEle.getElementsByClassName('markName')[0].style.top = circlePy+'%';
      // 给标注绑定点击事件
      const that = this;
      let item = this.annotationList.filter(item => item.imageMarkId == rect.id);
      divEle.getElementsByClassName('circle')[0].onclick = function () {
        if(that.isLayerOverlay){
          that.box.danger('请先退出标记图层叠加状态！');
          return;
        }
        if(that.params.mode=='edit' || that.params.mode == 'verify'){
          that.annotationClick(rect.id);
          that.setMarkToken(rect);
        }else{
          that.clickView({
            imageMarkId: rect.id
          });
        }
      }
      divEle.getElementsByClassName('markName')[0].onclick = function () {
        if(that.isLayerOverlay){
          that.box.danger('请先退出标记图层叠加状态！');
          return;
        }
        if(that.params.mode=='edit'|| that.params.mode == 'verify'){
          that.annotationClick(rect.id);
          that.setMarkToken(rect);
        }else{
          that.clickView({
            imageMarkId: rect.id
          });
        }
      }
    }else{
      divEle.innerHTML = '<div class="box"></div>';
    }
    return id;
  }

  // 将当前选择的标记信息添加到缓存中
  setMarkToken(data){
    let verifyConfig = {
      uuid: this.instanceModuleService.uuid2(),
      contentName: data.text,             // 标记名称
      contentModule: '',             // 错误模块
      foreignId: this.params.fileInfoId,  // 实体id
      contentId: data.id,    // 标记id
      recordType: 2,    // 1 实体  2 标记
    }
    this.jwt.setToKen('markVerifyConfig',JSON.stringify(verifyConfig));
  }

  //点击标注弹出标注编辑页面
  annotationClick(imageMarkId: string,isFromList?:boolean) {
    // 如果标记编辑组件为显示状态，说明当前存在正在进行编辑的标注
    if(this.params.showMarkEdit){
      // 判断表单内容是否发生变化
      if(this.markValueChange){
        this.trim.openCLick('当前标注信息未保存，是否确定离开？', (data) => {
          if (data) {
            // // 清除标注的选中状态
            // if(!this.params.currentMarkId){
            //   this.hEl.removeElementById('mark_current');
            // }else{
            //   let divEle = this.hEl.getElementById('mark_' + this.params.currentMarkId).element.getElementsByClassName('markOverlay');
            //   if(divEle && divEle.length>0){
            //     divEle[0].classList.remove("markEditing");
            //   }
            // }
            // 清除绘制的描边或点
            this.drawSurface('empty');
            this.hasDrawed = false;
            if (this.drawClassify == 1){
              $('.toggleStrokeBtn').trigger('click');
            }
            if (this.drawClassify == 2){
              $('.togglePointBtn').trigger('click');
            }
            // // 给当前标注添加选中状态
            // let divEle = this.hEl.getElementById('mark_' + imageMarkId).element.getElementsByClassName('markOverlay')[0];
            // divEle.classList.add("markEditing");
            // 修改当前标注id
            this.params.currentMarkId = imageMarkId;
            // 修改组件状态
            this.params.operateState = '1';
            // 获取当前选中标注的点集合
            let mark = this.annotationList.filter(item => item.imageMarkId == imageMarkId)[0];
            if(mark.point){
              this.point = {
                x: mark.point.split(',')[0],
                y: mark.point.split(',')[1],
              }
            }else{
              this.point = {};
            }
            this.clickPointArr = mark.points ? JSON.parse(mark.points) : [];
            this.params.points = mark.points ? JSON.parse(mark.points) : [];
            // 重新渲染标记信息
            this.drawAllMarks();
          }
        });
      }else{
        // 清除标注的选中状态
        if(!this.params.currentMarkId){
          this.hEl.removeElementById('mark_current');
        }else{
          let divEle = this.hEl.getElementById('mark_' + this.params.currentMarkId).element.getElementsByClassName('markOverlay');
          if(divEle && divEle.length>0){
            divEle[0].classList.remove("markEditing");
          }
        }
        // 清除绘制的描边或点
        this.drawSurface('empty');
        this.hasDrawed = false;
        if (this.drawClassify == 1){
          $('.toggleStrokeBtn').trigger('click');
        }
        if (this.drawClassify == 2){
          $('.togglePointBtn').trigger('click');
        }
        // 给当前标注添加选中状态
        let divEle = this.hEl.getElementById('mark_' + imageMarkId).element.getElementsByClassName('markOverlay')[0];
        divEle.classList.add("markEditing");
        // 修改当前标注id
        this.params.currentMarkId = imageMarkId;
        // 修改组件状态
        this.params.operateState = '1';
        // 获取当前选中标注的点集合
        let mark = this.annotationList.filter(item => item.imageMarkId == imageMarkId)[0];
        if(mark.point){
          this.point = {
            x: mark.point.split(',')[0],
            y: mark.point.split(',')[1],
          }
        }else{
          this.point = {};
        }
        this.clickPointArr = mark.points ? JSON.parse(mark.points) : [];
        this.params.points = mark.points ? JSON.parse(mark.points) : [];
      }
    }else{
      this.hasDrawed = false;
      // 显示标记编辑组件(如果当前展示了标注列表组件，需先关闭标注列表再打开标记编辑组件)
      if(this.params.showMarkList){
        this.toggleMarkList(false);
        setTimeout(()=>{
          this.toggleMarkEdit(true);
        },700);
      }
      // 显示标记编辑组件(如果当前展示了标注详情组件，需先关闭标注详情再打开标记编辑组件)
      else if(this.params.showMarkDetail){
        this.toggleMarkDetail(false);
        setTimeout(()=>{
          this.toggleMarkEdit(true);
        },700);
      }else{
        this.toggleMarkEdit(true);
      }
      // 给当前标注添加选中状态
      let divEle = this.hEl.getElementById('mark_' + imageMarkId).element.getElementsByClassName('markOverlay')[0];
      divEle.classList.add("markEditing");
      // 修改当前标注id
      this.params.currentMarkId = imageMarkId;
      // 修改组件状态
      this.params.operateState = '1';
      // 获取当前选中标注的点集合
      let mark = this.annotationList.filter(item => item.imageMarkId == imageMarkId)[0];
      if(mark.point){
        this.point = {
          x: mark.point.split(',')[0],
          y: mark.point.split(',')[1],
        }
      }else{
        this.point = {};
      }
      this.clickPointArr = mark.points ? JSON.parse(mark.points) : [];
      this.params.points = mark.points ? JSON.parse(mark.points) : [];
    }
  }

  // 显示/隐藏标记编辑组件
  toggleMarkEdit(state){
    this.params.showMarkEdit = state;
    this.setPicSize();
    if(state){
      $('#addMark').animate({
        'right': '20'
      }, 600);
    }else{
      $('#addMark').animate({
        'right': '-560'
      }, 600);
      // 清除标注选中效果
      if(this.params.currentMarkId){
        // 标注信息表单值发生变化需重新渲染标记
        if(this.markValueChange){
          this.params.currentMarkId = '';
          this.drawAllMarks();
        }
        // 未发生变化只需移除标记选中状态
        else{
          let divEle = this.hEl.getElementById('mark_' + this.params.currentMarkId).element.getElementsByClassName('markOverlay');
          if(divEle && divEle.length>0){
            divEle[0].classList.remove("markEditing");
          }
          this.params.currentMarkId = '';
        }
      }
      else{
        this.hEl.removeElementById('mark_current');
      }
      this.params.markName = '';
      this.markValueChange = false;
    }
    // 清除绘制的描边或点
    this.drawSurface('empty');
    if (this.drawClassify == 1){
      $('.toggleStrokeBtn').trigger('click');
    }
    if (this.drawClassify == 2){
      $('.togglePointBtn').trigger('click');
    }
  }

  // 显示/隐藏标记详情
  toggleMarkDetail(state){
    this.params.showMarkDetail = state;
    if(state){
      $('#queryMarkDetail').animate({
        'right': '20'
      }, 600);
    }else{
      $('#queryMarkDetail').animate({
        'right': '-560'
      }, 600);
      // 清除标注选中效果
      let divEle = this.hEl.getElementById('mark_' + this.params.currentMarkId).element.getElementsByClassName('markOverlay');
      if(divEle && divEle.length>0){
        divEle[0].classList.remove("markEditing");
      }
      this.params.currentMarkId = '';
      this.params.markName = '';
    }
    // 清除绘制的描边或点
    this.drawSurface('empty');
  }

  // 子组件保存标注后的回调
  addMarkCallback(event){
    if(!this.params.currentMarkId){
      this.hEl.removeElementById('mark_current');
    }
    this.params.currentMarkId = event.imageMarkId;
    this.params.markName = event.markName;
    this.markValueChange = false;
    // 查询对当前图片标注过的所有用户
    this.queryMarkCreater(true);
  }

  // 从标注列表中点击编辑按钮
  clickEdit(event){
    this.annotationClick(event.imageMarkId);
  }

  // 从标记列表中点击查看按钮
  clickView(event){
    if(this.params.showMarkList){
      this.toggleMarkList(false);
      setTimeout(()=>{
        this.toggleMarkDetail(true);
      },700);
    }

    if(this.params.showMarkEdit){
      this.toggleMarkEdit(false);
      setTimeout(()=>{
        this.toggleMarkDetail(true);
      },700);
    }
    
    if(!this.params.showMarkList && !this.params.showMarkEdit){
      this.toggleMarkDetail(true);
    }
    // 清除之前标记的选中状态
    if(this.params.currentMarkId){
      let divEle1 = this.hEl.getElementById('mark_' + this.params.currentMarkId).element.getElementsByClassName('markOverlay')[0];
      divEle1.classList.remove("markEditing");
    }
    // 给当前标注添加选中状态
    let divEle = this.hEl.getElementById('mark_' + event.imageMarkId).element.getElementsByClassName('markOverlay')[0];
    divEle.classList.add("markEditing");
    // 修改当前标注id
    this.params.currentMarkId = event.imageMarkId;
    // 获取当前选中标注的点集合
    let mark = this.annotationList.filter(item => item.imageMarkId == event.imageMarkId)[0];
    this.params.currentMarkName = mark.markName;
    if(mark.point){
      this.point = {
        x: mark.point.split(',')[0],
        y: mark.point.split(',')[1],
      }
    }else{
      this.point = {};
    }
    this.clickPointArr = mark.points ? JSON.parse(mark.points) : [];
  }

  // 获取复制标注的信息并进入该标记的编辑页面
  clickCopy(event){
    this.annotationList.push(event);
    let rect = {
      id: event.imageMarkId,
      text: event.markName,
      x: parseFloat(event.position.split(',')[0]),
      y: parseFloat(event.position.split(',')[1]),
      width: parseFloat(event.width),
      height: parseFloat(event.height),
      cx: event.point ? parseFloat(event.point.split(',')[0]) : null,
      cy: event.point ? parseFloat(event.point.split(',')[1]) : null,
    }
    this.addLayer(rect);
    // 触发标注点击事件
    this.annotationClick(event.imageMarkId);
    // 保存之后默认将缩放比例添加0.0001，使标注显示
    const zoom = this.viewer.viewport.getZoom();
    this.viewer.viewport.zoomTo(zoom + 0.0001);
    // 查询对当前图片标注过的所有用户
    this.queryMarkCreater(true);
  }

  // 子组件选中待删除标注后，父组件执行删除操作
  clickDelete(event){
    this.trim.openCLick('请确认是否删除当前选中的数据', (data) => {
      if (data) {
        // 当前用户为图片创建人或当前用户为管理员角色时，拥有对所有标注的删除权限
        const userRole = this.jwt.getToken('userRole');
        if(this.params.imgCreator == this.UserModel.userId || userRole == '知识库管理员'){
          this.deleteMark(event);
        }else{
          // 当前用户为当前选中标注的创建者时，拥有对该标注的删除权限
          let len = event.filter(item => item.createUserId != this.UserModel.userId).length;
          if(len == 0){
            this.deleteMark(event);
          }else{
            this.box.danger('很抱歉，其他用户创建的标注您没有删除权限！');
          }
        }
      }
    });
  }

  // 删除标注方法
  deleteMark(selectedData){
    let params = [];
    selectedData.forEach(element => {
      params.push(element.imageMarkId)
    });
    this.kmsService.deleteImgMarksById(params).subscribe(
      result => {
        if (result.code == '200') {
          this.box.success("删除成功");
          // 查询对当前图片标注过的所有用户
          this.queryMarkCreater(true);
        }else{
          this.box.waring(result.msg);
        }
      }
    );
  }

  // 根据取点绘制面
	drawSurface(type){
    this.drawType = type;
    let that = this;
		this.overlay = this.viewer.canvasOverlay({
			onRedraw:function() {
        let ctx = that.overlay.context2d();
        // 当前为清除描边操作
				if(that.drawType == 'empty'){
					ctx.clearRect(0,0,that.viewer.source.width,that.viewer.source.height);
					return;
        }

        // 回退一步导致清除
				if(that.drawType == 'backEmpty'){
					ctx.clearRect(0,0,that.viewer.source.width,that.viewer.source.height);
					return;
        }

        // 当前为标记图层叠加取点操作
        if(that.drawType == 'layerOverlay'){
          let points = that.overlayArr;
          points.forEach(element => {
            // 绘制圆环
            // 绘制外圈圆
            ctx.beginPath();
            ctx.fillStyle = that.strokeConfig.pointColor;
            ctx.arc(element.x,element.y,that.strokeConfig.outRadius1,0,2*Math.PI);
            ctx.closePath();
            ctx.fill();
            // 绘制内圈圆
            ctx.beginPath();
            ctx.fillStyle = that.strokeConfig.inCircleColor;
            ctx.arc(element.x,element.y,that.strokeConfig.inRadius1,0,2*Math.PI);
            ctx.closePath();
            ctx.fill();
          });
          return;
        }
       
        // 当前为取点操作
        if(that.drawType == 'point'){
					let point = that.point;
					// 绘制圆环
					// 绘制外圈圆
					ctx.beginPath();
					ctx.fillStyle = that.strokeConfig.pointColor;
					ctx.arc(point.x,point.y,that.strokeConfig.outRadius,0,2*Math.PI);
					ctx.closePath();
					ctx.fill();
					// 绘制内圈圆
					ctx.beginPath();
					ctx.fillStyle = that.strokeConfig.inCircleColor;
					ctx.arc(point.x,point.y,that.strokeConfig.inRadius,0,2*Math.PI);
					ctx.closePath();
          ctx.fill();
          return;
        }
        
        // 当前为双击，完成取点描边操作
				if(that.drawType == 'surface' && that.clickPointArr.length>=3){
					// 绘制所有点组成的面
					ctx.fillStyle = that.strokeConfig.areaColor;
					ctx.beginPath();
					ctx.moveTo(that.clickPointArr[0].x,that.clickPointArr[0].y);
					for(let j = 1;j<that.clickPointArr.length;j++){
						ctx.lineTo(that.clickPointArr[j].x,that.clickPointArr[j].y);
					}
					ctx.closePath(); 
					ctx.fill();
					
					// 绘制起始点与结束点之间的连线
					const firstPoint = that.clickPointArr[0];
					const lastPoint = that.clickPointArr[that.clickPointArr.length - 1];
					ctx.strokeStyle = that.strokeConfig.strokeColor;
					ctx.lineWidth = that.strokeConfig.strokeWidth;
					ctx.setLineDash(that.strokeConfig.lineDash);
					ctx.beginPath();
					ctx.moveTo(lastPoint.x,lastPoint.y);
					ctx.lineTo(firstPoint.x,firstPoint.y);
					ctx.closePath();
					ctx.stroke();
        }
        
				// 绘制连线
				ctx.strokeStyle = that.strokeConfig.strokeColor;
				ctx.lineWidth = that.strokeConfig.strokeWidth;
				ctx.setLineDash(that.strokeConfig.lineDash);
				for(let i=0;i<that.clickPointArr.length;i++){
					let point = that.clickPointArr[i];
					// 绘制当前点与上一个点之间的连线
					if(i>0){
						const prevPoint = that.clickPointArr[i - 1];
						ctx.beginPath();
						ctx.moveTo(prevPoint.x,prevPoint.y);
						ctx.lineTo(point.x,point.y);
					  ctx.closePath();
					  ctx.stroke();
					}
				}
				// 绘制点
				for(let i=0;i<that.clickPointArr.length;i++){
					let point = that.clickPointArr[i];
					// 绘制圆环
					// 绘制外圈圆
					ctx.beginPath();
					ctx.fillStyle = that.strokeConfig.outCircleColor;
					ctx.arc(point.x,point.y,that.strokeConfig.outRadius,0,2*Math.PI);
					ctx.closePath();
					ctx.fill();
					// 绘制内圈圆
					ctx.beginPath();
					ctx.fillStyle = that.strokeConfig.inCircleColor;
					ctx.arc(point.x,point.y,that.strokeConfig.inRadius,0,2*Math.PI);
					ctx.closePath();
					ctx.fill();
				}
			},
			clearBeforeRedraw:true
		});
		setTimeout(() => {
			const zoom = that.viewer.viewport.getZoom();
			this.viewer.viewport.zoomTo(zoom + 0.000001);
    },500);
		window.onresize = function(){
			that.overlay.resize();
		}
  }
  
  // 配置描边线条及圆圈的尺寸
  setStrokeConfig(width,height){
    this.strokeConfig.outRadius = 2;
    this.strokeConfig.inRadius = 1;
    this.strokeConfig.strokeWidth = 1;
    this.strokeConfig.outRadius1 = 1;
    this.strokeConfig.inRadius1 = 1;
    // let len = width<=height ? width : height;
    // if(len<=500){
    //   this.strokeConfig.outRadius = 2;
    //   this.strokeConfig.inRadius = 1;
    //   this.strokeConfig.strokeWidth = 1;
    // }else if(len<=1000){
    //   this.strokeConfig.outRadius = 4;
    //   this.strokeConfig.inRadius = 2;
    //   this.strokeConfig.strokeWidth = 1;
    // }else{
    //   let radius = Math.ceil(width * this.standardValue);
    //   this.strokeConfig.outRadius = radius>20 ? 20 : radius;
    //   const radius1 = this.strokeConfig.outRadius;
    //   let dashLen:number;
    //   if(radius1 <= 20){
    //     this.strokeConfig.inRadius = radius1*0.8;
    //     this.strokeConfig.strokeWidth = 2;
    //     dashLen = (radius1*0.8)/2;
    //   }else{
    //     this.strokeConfig.inRadius = radius1*0.6;
    //     this.strokeConfig.strokeWidth = 4;
    //     dashLen = (radius1*0.6)/2;
    //   }
    //   this.strokeConfig.lineDash = [dashLen,dashLen];
    // }
  }

  //执行与区域图描边有关的操作
  strokeOperation(event){
    switch(event.state){
      // 当前操作为查看描边
      case 'open': {
        if(this.drawClassify == 1){
          $('.toggleStrokeBtn').trigger('click');
        }
        this.hasDrawed = true;
        this.drawSurface('surface');
        break;
      };
      // 当前操作为关闭描边操作
      case 'close': {
        this.hasDrawed = false;
        this.drawSurface('empty');
        break;
      };
      // 当前操作为清除描边
      case 'empty': {
        this.hasDrawed = false;
        this.clickPointArr = [];
        this.params.operateState = '3';
        this.params.points = [];
        this.drawSurface('empty');
        break;
      };
      // case 'back': {
      //   if(this.clickPointArr.length > 0){
      //     this.clickPointArr = this.clickPointArr.slice(0, this.clickPointArr.length-1);
      //     if(this.clickPointArr.length == 0){
      //       this.drawSurface('backEmpty');
      //     }else{
      //       this.drawSurface('line');
      //     }
      //   }
      //   break;
      // };
    }
  }

  //执行与坐标定位点选择有关的操作
  pointOperation(event){
    switch(event.state){
      // 当前操作为查看取点操作
      case 'open': {
        if(this.drawClassify == 2){
          $('.togglePointBtn').trigger('click');
        }
        this.drawSurface('point');
        break;
      };
      // 当前操作为关闭取点操作
      case 'close': {
        this.drawSurface('empty');
        break;
      };
      // 当前操作为清除取点
      case 'empty': {
        this.point = {};
        this.params.operateState = '4';
        this.params.point = {};
        this.drawSurface('empty');
        break;
      };
    }
  }

  // 监听标记编辑组件表单内容是否改变
  formValueChangeOpe(event){
    this.markValueChange = event;
  }

  //拼接大图展示地址
  getIiifImgUrl(url){
    const pathArr = url.split('/');
    let res = environment.iiifImgUrl;
    for(let i=0;i<pathArr.length;i++){
      res += (i == pathArr.length -1 ? pathArr[i] + '/' : pathArr[i]+'%2F');
    }
    return res;
  }

  // 选中某一个实体
  selectInstance(index){
    this.instanceIndex = index;
    this.showInstanceList = false;
  }
  // 选中某一个实体
  selectInstance1(data){
    let param = { instanceId: data.instanceId };
    this.create.createModal(InstanceInfoViewComponent, param)
  }

  // 统计对当前图像进行标记过的用户
  queryMarkCreater(refreshMark?){
    this.kmsService.countMarkerUser(this.params.fileInfoId).subscribe(
      data => {
        if(data.code == '200'){
          let res = data.data;
          for(let i=0;i<res.length;i++){
            res[i]['checked'] = true;
          }
          if(this.createUserArr.length == 0){
            this.createUserArr = res;
          }else{
            for(let j=0;j<this.createUserArr.length;j++){
              if(res.filter(item => item.createUserName == this.createUserArr[j].createUserName).length > 0){
                res[j]['checked'] = this.createUserArr[j].checked;
              }
            }
            this.createUserArr = res;
          }

          let ids = [];
          this.createUserArr.forEach(element => {
            if(element.checked){
              ids.push(element.createUserId)
            }
          });
          // 向标注列表组件传值
          this.params.createUsers = ids.length == this.createUserArr.length ? [] : ids;
          if(refreshMark){
            this.drawAllMarks();
          }
        }else{
          this.box.danger(data.msg);
        }
      }
    );
  }

  
  // 筛选标记功能
  filterMarks(){
    let len = this.createUserArr.filter(item => item.checked).length;
    if(len == 0){
      this.box.danger('请至少选择一位创建人');
      return;
    }
    
    let ids = [];
    this.createUserArr.forEach(element => {
      if(element.checked){
        ids.push(element.createUserId)
      }
    });
    // 向标注列表组件传值
    this.params.createUsers = ids.length == this.createUserArr.length ? [] : ids;
    // 重新绘制标注
    this.drawAllMarks();
    this.modal.toggle();
    $('.markFilterBtn').find('img.selected').hide();
    $('.markFilterBtn').find('img.notSelected').show();
  }
  
  // 取消筛选标记功能
  cancelFilterMarks(){
    this.createUserArr = this.copyCreateUserArr;
    this.modal.toggle();
    $('.markFilterBtn').find('img.selected').hide();
    $('.markFilterBtn').find('img.notSelected').show();
  }

  // 判断当前标注创建人对应的复选框是否禁用
  isDisableCurrent(i){
    let items = this.createUserArr.filter(item => item.checked);
    if(items.length==1 && this.createUserArr[i].checked){
      return true;
    }else{
      return false;
    }
  }

  // 查询图片资源关联实体信息
  queryRelatedInstance(){
    this.kmsService.findFileRelatedInstance(this.params.fileInfoId).subscribe(
      data => {
        if(data.code == '200'){
          this.instanceArr = data.data;
        }
      }
    )
  }

  // 通过、驳回；并质检下一条
  verifyNext(event){
    if(event){
      this.box.info('操作成功！');
      event["mode"] = 'verify';
      this.tabServe.closeUrl('/kms/ResourcesMark', true);
      setTimeout(()=>{
        this.router.navigate(["/kms/ResourcesMark"], {
          queryParams: { Title: "审核图像标记", selectedData: JSON.stringify(event) },
        });
      },500);
    }else{
      this.box.info('所有待质检图像均已质检完成！');
      setTimeout(()=>{
        this.tabServe.closeUrl('/kms/ResourcesMark', true);
        this.tabServe.refurbis("/kms/ImgMarkQuery");
      },500);
    }
  }

  // 头部按钮点击事件
  clickToolbar(state){
    switch(state){
        case 'close': {
            this.componentState.emit(state);
            break;
        }
    }
  }

  // 从快捷菜单进入：pic容器大小发生变化时需调整图像显示大小
  setPicSize(){
    if(this.addPath == 'quickMenu'){
      setTimeout(() => {
        this.viewer.viewport.fitVertically();
      },500);
    }
  }
}
